import type { CSSProperties } from "react";
import { tagHue } from "../domain/tags";

interface TagPillProps {
  tag: string;
  /** When given, the pill is a button that opens the tag's view. */
  onOpen?(tag: string): void;
  /** When given, the pill has an x button that removes the tag. */
  onRemove?(tag: string): void;
}

export function TagPill({ tag, onOpen, onRemove }: TagPillProps) {
  const style = { "--tag-hue": tagHue(tag) } as CSSProperties;
  const label = <span className="tag-name">{tag}</span>;
  return (
    <span className="tag-pill" style={style} title={tag}>
      {onOpen === undefined ? (
        label
      ) : (
        <button
          type="button"
          className="tag-open"
          aria-label={`Tag ${tag}: show open tasks`}
          onClick={(event) => {
            event.stopPropagation();
            onOpen(tag);
          }}
        >
          {label}
        </button>
      )}
      {onRemove !== undefined && (
        <button
          type="button"
          className="tag-remove"
          aria-label={`Remove tag ${tag}`}
          onClick={(event) => {
            event.stopPropagation();
            onRemove(tag);
          }}
        >
          ×
        </button>
      )}
    </span>
  );
}
